import script from "./DashboardCourses.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardCourses.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardCourses.vue?vue&type=style&index=0&id=27ddb0aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27ddb0aa"]])

export default __exports__